module.exports = __webpack_public_path__ + "assets/img/search.8b49baae.svg";